export const EVENT_RED_PACKET = 'redPacket'
export const EVENT_DRAGON_TIGER_BOARD = 'dragonTigerBoard'
export const EVENT_GIVE_FREE_GAME = 'giveFreeGame'
export const EVENT_ROULETTE = 'roulette'
export const EVENT_FAKEACCOUNT_LIST = ['RU83','FF88','VVIP','PP58','BWIN','dm00']
